// extracted by mini-css-extract-plugin
export default {"root":"RegistrationModal_root__doYme","submit":"RegistrationModal_submit__JtnqM","close":"RegistrationModal_close__sXTZ4","background":"RegistrationModal_background__he1dE"};